<template>
    <Page>
        <div class="
            flex flex-col w-full justify-center items-center
            max-w-[880px] 2xl:max-w-[1100px] 3xl:max-w-[1300px]">
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-16 justify-center items-start w-full">
                <div class="flex flex-col gap-6">
                    <Image src="/connected-vehicles-logo.png" class="w-[90%] max-w-[400px] 2xl:max-w-[640px] mx-auto -ml-4" />
                </div>
                <Image src="/presidian-group-logo.png" class="w-[80%] max-w-[340px] 2xl:max-w-[600px] mx-auto -mt-6" />
            </div>
        </div>
        <div class="mt-10 2xl:mt-14 3xl:mt-20
                    text-base xl:text-lg 2xl:text-xl 3xl:text-2xl 
                    max-w-[880px] 2xl:max-w-[1100px] 3xl:max-w-[1300px]">
            <h2 class="mb-4 font-semibold">
                The partnership between Presidian and Connected Vehicles brings together 
                two trusted leaders in automotive innovation and customer retention
            </h2>
            <p class="font-normal text-white/80 mb-4">
                Through this collaboration, dealers gain access to the Carbucks program — a fully supported, 
                turnkey platform designed to boost customer loyalty, increase after-sales revenue, and 
                enhance dealership profitability. 
            </p>
            <p class="font-normal text-white/80">
                With Presidian's financial strength and operational experience combined with 
                Connected Vehicles' cutting-edge technology and dealer-focused solutions, this 
                partnership delivers a powerful ecosystem that supports long-term success 
                for participating dealerships.
            </p>
        </div>
    </Page>
</template>